import styled, { keyframes } from 'styled-components';
import {
	neutralWhite, primary800, blue400, neutral700,
	blue600, lightBlueBg, blue25, grayNearBlack,
	primary800Alpha75, primary800Alpha20, whiteAlpha65,
} from '../themes/colors';

export const Root = styled.div<{ $open?: boolean }>`
  position: relative;
  z-index: 10;
  display: ${({ $open }) => ($open ? 'block' : 'none')};
`;

export const Shell = styled.div`
  font-family: "Red Hat Display", sans-serif;
  position: relative;

  .rmdp-wrapper,
  .rmdp-shadow,
  .rmdp-calendar {
    position: static !important;
    transform: none !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .rmdp-shadow {
    background: ${neutralWhite};
    border-radius: 0;
    border: none;
    box-shadow: none;
    margin: 0 auto;
  }

  .rmdp-top-class {
    padding: 15px;
  }

  .rmdp-calendar {
    padding: 0;
  }

  .rmdp-day-picker {
    padding: 0;

    & > div {
      padding: 5px 20px 0;
    }
  }

  .rmdp-border-left {
    border: none;
  }

  .rmdp-header {
    z-index: 2;
  }

  .rmdp-header-values > span {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .rmdp-header-values > span::after {
    content: "▾";
    font-size: 12px;
    line-height: 1;
    color: ${primary800Alpha75};
    transform: translateY(1px);
  }

  .rmdp-arrow-container {
    position: absolute;
  }

  .rmdp-arrow {
    border-color: ${primary800};
    height: 10px;
    width: 10px;
  }

  .rmdp-left {
    left: 10px;
  }

  .rmdp-right {
    right: 10px;
  }

  .rmdp-arrow-container:hover {
    box-shadow: none;
    background: none;
  }

  .rmdp-arrow-container:hover .rmdp-arrow {
    border-color: ${blue400};
  }

  .rmdp-month-picker,
  .rmdp-year-picker {
    z-index: 5;
    border: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 0;
  }

  .rmdp-week-day {
    color: ${neutral700};
    font-weight: 400;
  }

  .rmdp-ep-arrow {
    display: none;
  }

  .rmdp-day.rmdp-selected span:not(.highlight) {
    box-shadow: none;
    background-color: ${blue600};
    color: ${neutralWhite};
  }

  .rmdp-range,
  .rmdp-range-hover {
    box-shadow: none;
    color: ${primary800};
    background-color: ${lightBlueBg};
    border-radius: 0 !important;
  }

  .rmdp-day span {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 4px;
  }

  .rmdp-range span,
  .rmdp-range-hover span {
    border-radius: 0 !important;
  }

  .rmdp-range.start span,
  .rmdp-range-hover.start span {
    border-radius: 4px !important;
    background-color: ${blue600} !important;
    color: ${neutralWhite} !important;
  }

  .rmdp-range.end span,
  .rmdp-range-hover.end span {
    border-radius: 4px !important;
    background-color: ${blue600} !important;
    color: ${neutralWhite} !important;
  }

  .rmdp-range.start.end span,
  .rmdp-range-hover.start.end span {
    border-radius: 4px !important;
  }

  .rmdp-day:not(.rmdp-disabled, .rmdp-day-hidden) span:hover {
    background-color: ${blue25};
    color: ${grayNearBlack};
  }

  .rmdp-range.start:hover span,
  .rmdp-range.end:hover span,
  .rmdp-range-hover.start:hover span,
  .rmdp-range-hover.end:hover span {
    background-color: ${blue600} !important;
    color: ${neutralWhite} !important;
  }
    
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: ${whiteAlpha65};
  backdrop-filter: blur(2px);
  display: grid;
  place-items: center;
  z-index: 10;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 3px solid ${primary800Alpha20};
  border-top-color: ${primary800};
  animation: ${spin} 0.8s linear infinite;
`;
